// SOLO match 生成ヘルパー (= DDSIM-18、 ADR-0028 §A/§B)。
//
// mockMatch.ts を置換。 cards.db からロードした実 catalog を使って
// EngineHandle.new_match を呼び出す。

import { EngineHandle, ensureEngineReady } from "@/lib/engine";
import { loadCatalog } from "@/lib/catalog";

// engine wasm を初期化し、 実 catalog + 指定デッキで new_match した EngineHandle を返す。
// deck は card_id_str の配列 (length 40〜60 必須)。
// new_match は JsError を throw しうるので呼び出し側で try/catch する。
export async function createSoloMatch(
  deckIds: string[],
  firstPlayer = 0,
): Promise<EngineHandle> {
  await ensureEngineReady();
  const catalog = await loadCatalog();
  // P1 / P2 とも同じ選択デッキを使う (= SOLO mode)
  return EngineHandle.new_match(deckIds, deckIds, catalog, firstPlayer);
}
